import { css } from 'styled-components';
// TODO do we want flex-basis
export var flex = function flex() {
  var justify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'center';
  var align = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'center';
  var flexDirecton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'row';
  var flexWrap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'nowrap';
  return css(["display:flex;justify-content:", ";align-items:", ";flex-direction:", ";flex-wrap:", ";"], justify, align, flexDirecton, flexWrap);
};
export var inlineFlex = function inlineFlex() {
  var justify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'center';
  var align = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'center';
  var flexDirecton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'row';
  var flexWrap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'nowrap';
  return css(["display:inline-flex;justify-content:", ";align-items:", ";flex-direction:", ";flex-wrap:", ";"], justify, align, flexDirecton, flexWrap);
};